<div
  class="wrapper"
  [appSlideToggle]="visible"
  [appSlideToggleTiming]="animation">
  @if (data) {
    <article [ngClass]="classes">
      @if (icon) {
        <app-icon [src]="icon" alt="icon"></app-icon>
      }
      <p>{{ data.message }}</p>
      @if (!data.duration) {
        <button
          app-icon-button
          src="assets/images/icons/close.svg"
          class="close"
          alt="{{ Translations.Close | translate }}"
          (click)="hide()">
          {{ Translations.Close | translate }}
        </button>
      }
    </article>
  }
</div>
